// extracted by mini-css-extract-plugin
export default {"content":"Content_content__6U+2i","linkPost":"Content_linkPost__TOI6k","linkAuthor":"Content_linkAuthor__MQoFu"};